import { apiClient } from "@/lib/api";
import type {
  PaginatedStandardResponse,
  PaginationInfo,
  ErrorResponse,
} from "@/types/api-response";
import { isErrorResponse, extractPaginatedData } from "@/types/api-response";
import type {
  PaymentGatewayEvent,
  PaymentGatewayEventListFilters,
} from "@/types/payment-gateway-event";

export const adminPaymentGatewayEventService = {
  /**
   * Get one page of the payment gateway log, newest first.
   * Returns: { data: PaymentGatewayEvent[]; pagination: PaginationInfo }
   */
  async getPaymentGatewayEvents(
    filters: PaymentGatewayEventListFilters,
  ): Promise<{ data: PaymentGatewayEvent[]; pagination: PaginationInfo }> {
    const params = new URLSearchParams();

    if (filters.search) params.append("search", filters.search);
    params.append("page", filters.page.toString());

    // The API calls the page size "limit"; the screen calls it pageSize.
    params.append("limit", filters.pageSize.toString());

    const response = await apiClient.get<
      PaginatedStandardResponse<PaymentGatewayEvent> | ErrorResponse
    >(`/api/v1/admin/payment-gateway-events?${params.toString()}`);

    if (isErrorResponse(response.data)) {
      throw new Error(response.data.error.message);
    }

    return extractPaginatedData(response.data);
  },
};
